import React, { Component } from 'react';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import Dropzone from 'react-dropzone';
import Typography from '@material-ui/core/Typography';
import InboxIcon from '@material-ui/icons/Inbox';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
    getSelectedLookaheadId,
    lookaheadTagFBConnect, getAreas, makeGetAreaData
} from '../selectors/lookahead.selector';
import { getProjectId } from '../selectors/project.selector';
import { ThunkDispatch } from 'redux-thunk';
import { firebaseConnect } from 'react-redux-firebase';
import { withRouter } from "react-router";
import { withStyles } from '@material-ui/core';
import { areaStyle } from '../containers/dockPadStyle'
import { areaActions } from '../actions/area.actions';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { Area } from '../models/Area';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';

import EditAreaDialog from './Dialogs/EditAreaDialog'
import EditAreaZoneDialog from './Dialogs/EditAreaZoneDialog';
import { withFirebase } from 'react-redux-firebase';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export interface Props {
    classes: ClassNameMap;
    uploadArea: (file: File | Blob) => Promise<{
        area: Area;
        areaKey: string | null;
    }>,
    areas: Record<string, Area>;
    openEditAreaDialog: (key: string) => Promise<void>;
    openEditAreaZoneDialog: (key: string) => Promise<void>
}

export type State = {
    deleteOpen: boolean
}

export interface AreaItemProps {
    openEditAreaZoneDialog: (key: string) => Promise<void>
    deleteAreaZone: (areaId: string) => Promise<void>;
    uid: string
    classes: ClassNameMap;
    area: Area,
    projectId: string,
    firebase: any
}

export type AreaItemState = {
    fileUrl?: string,
    deleteOpen: boolean
}

export class _AreaItem extends Component<AreaItemProps, AreaItemState> {
    state = {
        fileUrl: "",
        deleteOpen: false
    }

    componentDidUpdate(prevProps: AreaItemProps, prevState: AreaItemState) {
        const { area } = this.props
        if (area.thumbnailStatus == 'Done' && !this.state.fileUrl) {
            this.loadThumbnail()
        }
    }

    onEditAreaZone = (key: string) => {
        const { openEditAreaZoneDialog } = this.props
        openEditAreaZoneDialog(key)
    }

    loadThumbnail = async () => {
        const { projectId, uid, area } = this.props

        if (area.thumbnailStatus != 'Done' || !!this.state.fileUrl) {
            return
        }

        const entityRoute = `/blueprints/projects/${projectId}/areas/${uid}`

        const storageRef = this.props.firebase.storage().ref().child(`${entityRoute}/${area.fileName}`)



        const downloadUrl = await storageRef.getDownloadURL()


        this.setState({
            fileUrl: downloadUrl
        })
    }

    componentDidMount() {
        const { area } = this.props
        if (area.thumbnailStatus == 'Done' && !this.state.fileUrl) {
            this.loadThumbnail()
        }
    }

    handleClickOpen = () => {
        this.setState({
            deleteOpen:true
        })
    };

    handleClose = () => {
        this.setState({
            deleteOpen:false
        })
    };

    deleteArea = async () => {
        const {  deleteAreaZone, uid } = this.props
        await deleteAreaZone(uid)
        this.handleClose()
    }

    render() {
        const { classes, uid, area } = this.props
        const { fileUrl } = this.state

        return (
            <React.Fragment>
                <Dialog
                    open={this.state.deleteOpen}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Do you want to delete?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Do want to delete <span style={{color: 'red'}}>{area.name}</span> Area? Warning this cannot be undone.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Cancel
                        </Button>
                        <Button color="secondary" onClick={this.deleteArea} autoFocus>
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
                <div style={{ "background-size": "cover", "background-repeat": "no-repeat", backgroundImage: `url("${fileUrl}")` }} className={classNames(classes.AreaScreenCollectionItem)}>
                    <div className={classNames(classes.AreaScreenCollectionBlueprint)}>
                        <div className={classNames(classes.AreaBlueprintItemRow)}>
                            {area.name}
                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <div onClick={() => this.onEditAreaZone(uid)} >
                                    <EditIcon />
                                </div>
                                <div onClick={() => this.handleClickOpen()} >
                                    <CloseIcon />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

const makeAreaMapStateToProps = () => {
    const getAreaData = makeGetAreaData();
    const mapStateToProps = (state: any, ownProps?: any) => ({
        area: getAreaData(state, ownProps),
        projectId: getProjectId(state)
    });
    return mapStateToProps;
}

const mapAreaItemDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        openEditAreaZoneDialog: (key: string) => dispatch(areaActions.openEditAreaZoneDialog(key)),
        deleteAreaZone: (key: string) => dispatch(areaActions.deleteAreaZone(key))

    }
};

const AreaItem = compose(
    withFirebase,
    withStyles(areaStyle, { withTheme: true }),
    connect(makeAreaMapStateToProps, mapAreaItemDispatchToProps),
)(_AreaItem)

export class _AreaCollection extends Component<Props, State> {
    state = {
        deleteOpen: false
    }

    renderEmptyArea = () => {
        const { classes, areas } = this.props;
        if (Object.keys(areas).length > 0) {
            return
        }
        return (
            <div className={classNames(classes.AreaScreenEmptyContainer)}>
                <Dropzone
                    className={classes.AreaDropzoneStyle}
                    onDrop={this.onFileUpload}>
                    <div
                        className={classes.AreaDropzoneContainer}>
                        <InboxIcon style={{ color: '#3973BE', width: '48px', height: '48px' }} />
                        <Typography style={{ color: '#3973BE' }}>
                            Drag plan here or upload from disk
                            </Typography>
                        <Button variant="contained" color="primary">
                            Upload
                            </Button>
                    </div>
                </Dropzone>
            </div>
        );
    };

    onFileUpload = async (accepted: any, rejected: any) => {
        const { uploadArea, openEditAreaDialog } = this.props
        const file = accepted[0]
        if (!file) {
            return
        }
        const fileUpload = await uploadArea(file)

        await openEditAreaDialog(fileUpload.areaKey)
    };

    onEditAreaZone = (key: string) => {
        const { openEditAreaZoneDialog } = this.props
        openEditAreaZoneDialog(key)
    }

    renderAreas = () => {
        const { classes, areas } = this.props;


        return Object.keys(areas).map(key => {
            const area = areas[key]
            return (
                <AreaItem uid={key} />
            )
        })
    }
    renderAreaCollection = () => {
        const { classes, areas } = this.props;

        if (!areas || Object.keys(areas).length <= 0) {
            return
        }
        return (
            <div className={classNames(classes.AreaScreenCollectionContainer)} >
                {this.renderAreas()}
                <div className={classNames(classes.AreaScreenCollectionItem)}>
                    <Dropzone onDrop={this.onFileUpload} style={{ width: '100%', height: '100%', border: '1px dashed #3973BE', 'border-radius': '4px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <AddIcon style={{ color: '#3973BE', width: '22px', height: '22px' }} />
                    </Dropzone>
                </div>
            </div>
        )
    }




    render() {

        return (
            <React.Fragment>


                {this.renderEmptyArea()}
                {this.renderAreaCollection()}
                <EditAreaDialog />
                <EditAreaZoneDialog />
            </React.Fragment>
        );
    }
}



const mapStateToProps = (state: any) => ({


    areas: getAreas(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        uploadArea: (file: File | Blob) => dispatch(areaActions.uploadArea(file)),
        openEditAreaDialog: (key: string) => dispatch(areaActions.openEditAreaDialog(key)),
        openEditAreaZoneDialog: (key: string) => dispatch(areaActions.openEditAreaZoneDialog(key)),


    }
};

export const AreaCollection = compose<React.ComponentClass>(
    connect(state => {
        return {
            projectId: getProjectId(state),
            lookaheadId: getSelectedLookaheadId(state)
        };
    }),
    firebaseConnect(lookaheadTagFBConnect),
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(areaStyle, { withTheme: true }),

)(_AreaCollection)



// WEBPACK FOOTER //
// ./src/components/AreaCollection.tsx